
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {ucretDurumuOzetle, UcretDurumuOzeti} from "@/components/eicrapro/sorgu/ucretliSorguDurumu";
import * as bakiyeMemo from "@/components/eicrapro/sorgu/bakiyeMemo";

/**
 * Faz 4 (DEV-3217 / DEV-3218) — canlı UYAP sorgusu için ücret onayı.
 *
 * Onaysız canlı sorgu atılmaz: `forceFresh` yalnız bu diyalogdan geçtikten sonra
 * çalışır. Projede genel bir Confirm/Onay bileşeni yok (en yakın aday
 * `DeleteBuroDialog` Büro silme API'sine sabitlenmiş); bu yüzden
 * `SenkronPlanListesi.vue:78-91`'deki yerel `v-dialog` + boolean deseni tek bir
 * yerde toplandı ve İP3 (kaynak rozeti) ile İP4 (haciz ekranı onayı) aynı
 * bileşeni kullanıyor.
 *
 * DEV-3346-BAKIYE: koruma korunur (diyalog açılınca hak durumu yine sorulur),
 * ama aynı dosyaId için `bakiyeMemo` KISA MEMO'suyla 60 sn içindeki ikinci
 * açılış UYAP'a gitmez — form 5 rozet içeriyor ve kullanıcı açıp kapadıkça
 * her seferinde ücretsiz de olsa bir UYAP isteği + 1 sn tempo harcanıyordu.
 */
@Component({components: {}})
export default class UcretliSorguOnayDialog extends Vue {
  @Prop({default: false}) value!: boolean;
  /** Kullanıcı hangi sorguyu yenilediğini görsün (örn. "Banka hesap bilgileri"). */
  @Prop({default: ""}) alanAdi!: string;
  @Prop({default: false}) yukleniyor!: boolean;
  /**
   * Verilirse diyalog açılırken UYAP'a "bu dosyada günlük hak kaldı mı" diye
   * SORULUR. Yenile yolu `DosyaBorclu.kotaIslemleri()`nden geçmediği için
   * (kota kapısı orada, `UyapRequest`te değil) bakiyeden sessizce ücret düşmesini
   * engelleyen tek koruma bu onaydır.
   */
  @Prop() dosyaId!: string | number;

  hakSoruluyor = false;
  bakiye: any = null;
  /** Cevap UYAP'a sorulmadan `bakiyeMemo`dan mı geldi (kullanıcıya bilgi notu için). */
  bakiyeMemodan = false;

  get ozet(): UcretDurumuOzeti {
    return ucretDurumuOzetle(this.bakiye);
  }

  get acik(): boolean {
    return this.value;
  }

  set acik(v: boolean) {
    this.$emit("input", v);
  }

  @Watch("value")
  async acildi(acik: boolean) {
    if (!acik || !this.dosyaId) {
      return;
    }

    this.bakiye = null;
    this.bakiyeMemodan = false;

    // DEV-3346-BAKIYE: 60 sn içindeki ikinci açılış UYAP'a gitmez, memo'daki
    // cevap gösterilir. Memo yoksa/süresi dolmuşsa koruma değişmez: hak
    // durumu yine UYAP'a SORULUR (gün içinde başka sorgularla tükenmiş olabilir).
    const simdi = Date.now();
    const memoCevabi = bakiyeMemo.oku(this.dosyaId, simdi);
    if (memoCevabi !== undefined) {
      this.bakiye = memoCevabi;
      this.bakiyeMemodan = true;
      return;
    }

    this.hakSoruluyor = true;
    try {
      this.bakiye = await this.$uyap.SorguBakiyesi().run({dosyaId: String(this.dosyaId)});
      // Hata/boş cevap memo'ya YAZILMAZ — "sorulamadı" durumu "hak var" gibi
      // önbelleğe düşerse bir sonraki açılış yanlış temkinsiz görünür.
      if (this.bakiye) {
        bakiyeMemo.yaz(this.dosyaId, this.bakiye, simdi);
      }
    } catch (e) {
      // Sorulamadıysa uyarı en temkinli hâlinde kalır (ucretDurumuOzetle: bilinmiyor).
      this.bakiye = null;
    } finally {
      this.hakSoruluyor = false;
    }
  }

  onayla() {
    if (this.hakSoruluyor || this.yukleniyor) {
      return;
    }
    // Kullanıcı ücretli sorguyu GERÇEKTEN onayladı: bu dosyada hak sayısı
    // değişmiş olabilir, memo'daki eski cevap bir daha gösterilmesin.
    bakiyeMemo.gecersizKil(this.dosyaId);
    this.$emit("onay");
  }

  vazgec() {
    // kod inceleme: "vazgec" emit'i hiçbir yerde dinlenmiyordu (dialog
    // kapanması zaten v-model üzerinden "input" ile sağlanıyor) — kaldırıldı.
    this.$emit("input", false);
  }
}
